module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "maps"
    }
  }, [_c('h1', {
    staticStyle: {
      "margin-top": "3em",
      "font-size": "1.5em",
      "font-weight": "normal"
    }
  }, [_vm._v("LIST OF MAPS")]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "font-size": ".9em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/14_chapter_4#map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NORTH SEA, NORWAY AND MURMANSK")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "font-size": ".9em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/16_chapter_6#map2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MEDITERRANEAN")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "font-size": ".9em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/24_chapter_13#map3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INDIAN OCEAN, CEYLON TO MALACCA STRAITS")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "font-size": ".9em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/25_chapter_14#map4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MALACCA STRAITS, IN THE NARROWS")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "font-size": ".9em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/27_chapter_16#map5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ANDAMAN ISLANDS, PORT BLAIR")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "font-size": ".9em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/28_chapter_17#map6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PULO WEH AND SABANG")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "font-size": ".9em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/30_chapter_19#map7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("MERGUI ARCHIPELAGO, NORTHERN HALF")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "font-size": ".9em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/32_chapter_21#map8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("LOMBOK STRAIT")])]), _vm._v(" "), _c('p', {
    staticClass: "paranoindent1",
    staticStyle: {
      "font-size": ".9em"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/32_chapter_21#map8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("WESTERN AUSTRALIA AND DUTCH EAST INDIES ("), _c('em', [_vm._v("inset")]), _vm._v(")")])]), _vm._v(" "), _c('p', {
    staticClass: "paracenter",
    staticStyle: {
      "font-size": "1.1em"
    }
  }, [_vm._v("("), _c('em', [_vm._v("The maps were prepared by K. C. Jordan")]), _vm._v(")")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17cb9708","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/08b_maps.vue
// module id = 81
// module chunks = 0